<div>
  <h6 class="odx-title-6" i18n="@@global.protectiveTubes">Schutzrohre</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addProtectiveTube()"
      [odxTooltip]="tooltipTextAddProtectiveTube"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragProtectiveTube()"
    ></app-add-button>
    <app-toggle-visibility-button
      [visible]="floorplanState.protectiveTubesVisible"
      (toggleEvent)="floorplanState.protectiveTubesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.protectiveTubesItemTextVisible"
      (toggleEvent)="updateProtectiveTubesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.protectiveTubesLocked"
      (toggleEvent)="floorplanState.protectiveTubesLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
